import { z } from "zod";
import { ulidSchema } from "./schemas.js";
export const adminResumeTokenSchema = z.string().regex(/^[A-Za-z0-9_-]{32}$/u);
export const adminResumeTargetSchema = z
    .object({ kind: z.enum(["BOOK", "CUSTOMER"]), id: ulidSchema })
    .strict();
export const adminResumeCreateSchema = z.object({ target: adminResumeTargetSchema }).strict();
export const adminResumeResolveSchema = z.object({ token: adminResumeTokenSchema }).strict();
export const adminResumeCreatedSchema = z
    .object({
    data: z
        .object({
        token: adminResumeTokenSchema,
        expiresAt: z.string().datetime(),
        scope: z.literal("CURRENT_BUSINESS_OWNERS_ONLY"),
    })
        .strict(),
})
    .strict();
export const adminResumeResolvedSchema = z
    .object({
    data: z
        .object({
        target: adminResumeTargetSchema,
        expiresAt: z.string().datetime(),
        scope: z.literal("CURRENT_BUSINESS_OWNERS_ONLY"),
    })
        .strict(),
})
    .strict();
//# sourceMappingURL=admin-investigation-resume.js.map